module.exports = __webpack_public_path__ + "img/grid-grouping.e1d2c441.png";